import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const calorieTrackingBefore = useStore((state) => state.calorieTrackingBefore);
  const setCalorieTrackingBefore = useStore((state) => state.setCalorieTrackingBefore);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.calorieTrackingBefore.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={calorieTrackingBefore}
          onChange={(value) => {
            setCalorieTrackingBefore(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'calorie-tracking-before',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Yes"}>
            <span>✅</span> {t('onboarding.calorieTrackingBefore.options.yes')}
          </Option>
          <Option value={"No"}>
            <span>❌</span> {t('onboarding.calorieTrackingBefore.options.no')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
